import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

const FAQ_ITEMS = Array.from({ length: 8 }, (_, i) => i + 1);

function FaqItem({ index }: { index: number }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border border-gray-100 rounded-2xl overflow-hidden transition-all duration-300 hover:border-gray-200">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
      >
        <span className="font-heading text-base font-semibold text-foreground-950 pr-4">
          {t(`trafficPro.faq${index}Q`)}
        </span>
        <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${isOpen ? 'bg-primary-500 text-white rotate-45' : 'bg-gray-100 text-foreground-500'}`}>
          <i className="ri-add-line text-lg"></i>
        </div>
      </button>
      <div
        className={`transition-all duration-400 ease-out overflow-hidden ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
      >
        <div className="px-5 md:px-6 pb-5 md:pb-6 text-foreground-600 text-sm leading-relaxed">
          {t(`trafficPro.faq${index}A`)}
        </div>
      </div>
    </div>
  );
}

export default function FAQ() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-4">
              {t('trafficPro.faqTag')}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
              {t('trafficPro.faqTag')}
            </h2>
          </div>
        </ScrollReveal>

        <div className="space-y-3">
          {FAQ_ITEMS.map((n) => (
            <ScrollReveal key={n} delay={n * 0.04}>
              <FaqItem index={n} />
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}